type CanopyGeneCountBadgeProps = {
  totalGenes: number;
  color?: string;
  className?: string;
};

export function CanopyGeneCountBadge({ totalGenes, color, className = '' }: CanopyGeneCountBadgeProps) {
  const rounded = Math.round(totalGenes);
  const count = rounded.toLocaleString('en-US');
  const label = rounded === 1 ? 'gene' : 'genes';
  const accent = color ?? '#0369a1';

  return (
    <span
      className={`inline-flex max-w-full items-baseline gap-1 text-[0.65rem] leading-none ${className}`}
      title={`${count} associated ${label}`}
    >
      <span
        className="rounded px-1.5 py-0.5 font-bold tabular-nums text-white"
        style={{ background: accent }}
      >
        {count}
      </span>
      <span className="font-medium tracking-wide text-slate-500">{label}</span>
    </span>
  );
}
